import { StoreState } from '@/core/models/store.interface';
import { CancelToken } from 'axios';
import { Module } from 'vuex';
import { ResumeService } from './resume.service';
const service = new ResumeService();

export interface ResumeState {}

const ResumeStore: Module<ResumeState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async parseResume(context, { resumes, resume_url, cancelToken }: { resumes?: File; resume_url?: string; cancelToken: CancelToken }) {
         const response = await service.parseResume(cancelToken, resumes, resume_url);
         return response;
      },
      async processResumes(context, payload: { files: Array<File>; cancelToken: CancelToken }) {
         const response = await service.processResumes(payload.cancelToken, payload.files);
         return response;
      },
   },
};

export default ResumeStore;
